import React from "react";
import { Spinner as SpinnerEC } from "@trussle/external-components";
import cn from "classnames";
import "./styles.scss";

interface ISpinnerProps {
  visible?: boolean;
}

export const Spinner: React.FC<ISpinnerProps> = ({ visible = true }) => (
  <div className={cn("heroff2-spinner-container", { "heroff2-spinner-container--visible": visible })}>
    <SpinnerEC role="status" />
  </div>
);
